import { Button, Modal, Stack } from 'canoe';
import { ENDPOINTS, useActions } from 'hammock';
import React from 'react';

import useToggle from 'commons/hooks/useToggle';

import TemplateForm from './TemplateForm';

const CreateTemplate = () => {
  const [isOpen, toggle] = useToggle();
  const { create } = useActions(ENDPOINTS.templateMetadata);
  const { update } = useActions(ENDPOINTS.templateDocumentsEditor);
  const { get: getDocumentContent } = useActions(ENDPOINTS.documentsEditor);
  const { get: getContentSegments } = useActions(ENDPOINTS.contentSegments);

  const getFirstDocumentId = async (contentId) => {
    const resource = await getContentSegments({ id: contentId });
    const documentId = resource?.segmentDocuments[0]?.documentId;
    if (!documentId) {
      throw new Error("content doesn't have any documents");
    }
    return documentId;
  };

  const handleSubmit = async (contentMeta) => {
    const documentId = contentMeta.defaultDocumentId ?? (await getFirstDocumentId(contentMeta.id));
    const resource = await getDocumentContent({ id: documentId });

    if (resource) {
      // Create template
      const { id } = await create({
        body: {
          name: contentMeta.name,
          enabled: true,
          image: '',
          tutorialTreeHash: resource.versionId,
        },
      });
      // Populate template
      try {
        await update({
          id,
          body: { ...resource, id },
          onErrorNotification: false,
          onSuccessNotification: false,
        });
      } catch (e) {
        // ignore this error when create a template from a content that has errors.
      }
      toggle();
    }
  };

  return (
    <React.Fragment>
      {isOpen && (
        <Modal onClose={toggle} severity="Info" closeOnClickOutside overflow="visible">
          <TemplateForm onCancel={toggle} handleSubmit={handleSubmit} />
        </Modal>
      )}
      <Stack justify="center">
        <Button appearance="outline" variant="primary" onClick={toggle}>
          Create New Template
        </Button>
      </Stack>
    </React.Fragment>
  );
};

export default CreateTemplate;
